import { Prompt } from "../types/ChatTypes";

// Mock prompt data
export const defaultPrompts: Prompt[] = [
  {
    title: "General Questions",
    description:
      "Ask about drug information, clinical trials, side effects, and more.",
  },
  {
    title: "Data Analysis",
    description:
      "Request data summaries, trends, and statistical insights on the Astrazeneca drug portfolio.",
  },
  {
    title: "Comparative Insights",
    description:
      "Compare different drugs within the Astrazeneca portfolio based on efficacy, safety, and market performance.",
  },
];

// Mock timeline data
export const timelineData = [
  {
    title: "Research workspace ready",
    subtitle: "Initialized in Scientific Mode",
    time: "0s",
  },
  {
    title: "Research strategy finalized",
    subtitle: "Selected tools: COMP, LIT",
    time: "1s",
  },
  {
    title: "Information gathering complete",
    subtitle: "Searched 2 data sources",
    time: "1s",
    actions: ["AZ Compound Search (1.57s)", "BIKG Document Search (1.45s)"],
    query: {
      title: "AZ Compound Search Query",
      code: `{
  "query": [
    {
      "compound_name": "b-alanine",
      "query_type": "synonym_only"
    }
  ]
}`,
    },
    sources: [
      {
        url: "https://explorer.dmta.astrazeneca.net/compound/203287908",
      },
      {
        url: "https://explorer.dmta.astrazeneca.net/compound/203287908",
      },
    ],
  },
];
